module.exports = __webpack_public_path__ + "static/media/move.c3ee8be6.png";